<template functional>
  <div
    class="content-banners columns is-hidden-mobile"
    data-analytics-id="homepage-container"
    data-analytics-label="Discover"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'ContentBannerList'
}
</script>

<style scoped>
.content-banners {
  margin-top: 24px;
  margin-bottom: 24px;
}
</style>
